import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { sessionContractIdSelector } from '../../../redux/session/contract/selectors'
import { fetchDeliverySubscriptions } from '../service/deliverySubscriptionService'
import deliverySubscriptionQueryKeys from './deliverySubscriptionQueryKeys'

export const useDeliverySubscriptions = () => {
  const contractId = useSelector(sessionContractIdSelector)

  return useQuery({
    queryKey: deliverySubscriptionQueryKeys.list(contractId),
    queryFn: () => fetchDeliverySubscriptions(contractId),
    enabled: !!contractId,
    select: data => [...data].sort((a, b) => b.id - a.id)
  })
}
